<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card style="    height: 90vh; background-image: url(/web/img/mscope-logo.png); background-position: center; background-repeat: no-repeat;">
        <div slot="header">
          <strong> mScope Competitive Mapping Sets</strong>
        </div>
        <b-row v-if="(vehicleSets.length >= 1)">
          <b-col md="2" class="m-0 p-0">
            <b-btn variant="primary" class="w-100" @click="createMappingSet"><span class="fa fa-plus text-white mr-2"></span>Add New Competitive Mapping Set</b-btn>
            <b-list-group>
              <b-list-group-item :id="vs.SetId.toString()" v-for="vs in mappingSets"
                                 @click="changeActiveSet(vs)" button class="p-0">
                <div class="d-flex w-100 h-100" v-bind:class="[(vs.SetId === -1) ? 'alert-success' : '', (vs.SetId == activeMappingSet.SetId) ? 'alert-primary': '']" style="padding: 10px 10px 10px 20px;">
                  <span>{{ vs.Name }}</span>
                </div>
              </b-list-group-item>
              <b-list-group-item v-if="!mappingSets.length" button class="d-flex justify-content-between align-items-center" style="padding: 5px 5px 5px 20px;">
                <div class="d-flex">
                  <span>No sets created yet.</span>
                </div>
              </b-list-group-item>
            </b-list-group>
            <!--<dxList id="selMappingSet"
                  style="width: 100%;"
                  :items="mappingSets"
                  display-expr="Name"
                  name="Select a Mapping Set"
                  selection-mode="single">
            <template #item="item">
              <div @click="changeActiveSet(item.data)" v-bind:class="(item.data.SetId === -1) ? 'alert-success' : ''">
                {{ item.data.Name }}
              </div>
            </template>
          </dxList>-->
          </b-col>
          <b-col md="10" class="m-0 p-2" v-if="(activeMappingSet.Name != undefined)">
            <b-row class="d-flex m-0 p-1">

              <label for="selVehicleSet" class="mr-auto h4">{{activeMappingSet.Name}}</label>
              <b-button variant="success" class="btn mr-2" @click="saveMappingSet()" :disabled="(activeMappingSet.SetId == -1)"
                        v-b-tooltip.hover title="Save this mapping set">
                <i class="fa fa-save mr-2"></i>Save Set
              </b-button>
              <b-button variant="success" class="btn mr-2" v-b-modal.modal-prevent-closing
                        v-b-tooltip.hover title="Save this mapping set as">
                <i class="fa fa-save mr-2"></i>Save Set As
              </b-button>
              <b-button variant="danger" class="btn" @click="deleteMappingSet()"
                        v-b-tooltip.hover title="Delete this mapping set">
                <i class="fa fa-trash mr-2"></i>Delete
              </b-button>

            </b-row>
            <b-row class="d-flex align-items-stretch bg-white">
              <b-col md="4" class="m-0 p-1">
                <b-card no-body class="h-100">
                  <div slot="header" class="d-flex p-0 m-0">
                    <label for="selVehicleSet" class="h6 mr-auto pt-2 ">Vehicle Set:</label>
                    <dx-select-box id="selVehicleSet"
                                   :items="vehicleSets"
                                   display-expr="Name"
                                   class="w-75 m-0 p-0"
                                   value-expr="VehicleSetId"
                                   v-model:value="activeVehicleSetId"
                                   name="Select a Vehicle Set"
                                   placeholder="Select Vehicle Set">
                    </dx-select-box>
                  </div>
                  <DxList id="listTrackedVehicles"
                          :data-source="trackedVehicles"
                          class="p-1 "
                          height="65vh"
                          :search-enabled="true"
                          search-mode="contains"
                          search-expr="LongDescription"
                          :show-selection-controls="true">
                    <template #item="item">
                      <div @click="changeActiveTrackedVehicle(item.data.VehicleID)" v-bind:class="[(item.data.MappedIds ===undefined || item.data.MappedIds.length >0) ? '' : 'alert-warning',
                             (item.data.Changed == true) ? 'alert-success p-2': '']">

                        <div class="d-flex">
                          <strong class="flex-shrink-1 mr-2">{{item.data.Year}}</strong>
                          <label>
                            {{item.data.Make}}  {{item.data.Model}}

                          </label>
                          <label class="ml-auto">{{item.data.MSRP | currency('$')}}</label>
                        </div>
                        <div class="row ml-2">
                          {{item.data.ShortDescription}}({{item.data.MsCode}})
                        </div>
                      </div>
                    </template>
                  </DxList>
                </b-card>
              </b-col>
              <b-col class="m-0 p-1">
                <b-card no-body class="m-0 p-0">
                  <div slot="header" class="h6 d-flex">
                    Competitive Vehicles for {{getVehicleName(activeVehicle)}}
                    <label class="ml-auto" v-if="activeVehicle != undefined">MSRP: {{activeVehicle.MSRP | currency('$') }}</label>
                  </div>
                  <div class="m-0 p-0">

                    <DxList id="listMappedVehicles"
                            show-scrollbar="always"
                            :data-source="currentMappedVehicles"
                            height="55vh"
                            class="m-0 p-1 border"
                            :allow-item-deleting="true"
                            :on-item-deleted="competitiveVehicleDeleted"
                            :search-enabled="true"
                            search-mode="contains"
                            search-expr="LongDescription">
                      <template #item="item">
                        <div class="d-flex">
                          <strong class="flex-shrink-1">{{item.data.Year}}</strong>
                          <label class="w-25 pl-2">{{item.data.Make}}</label>
                          <label class="w-50">
                            {{item.data.Model}}<br />{{item.data.ShortDescription}}({{item.data.MsCode}})
                          </label>
                          <label class="ml-auto">MSRP {{item.data.MSRP | currency('$')}}</label>
                        </div>

                      </template>
                    </DxList>
                  </div>
                  <div class="m-2 p-2">
                    <div class="d-flex">
                      <strong>Add a Competitive Vehicle: </strong>
                      <a href="#" class="btn btn-link ml-auto" @click="addMSISCompetitiveVehicles"
                         v-b-tooltip.hover title="This will append the default marketscan competitive vehicles to your competitive set">Restore Market Scan Competitive Vehicles</a>
                    </div>
                    <div>

                      <b-row align-h="between">
                        <b-col md="10" align-self="start">
                          <ymmtlookup id="addCompetitiveVehicle" ref="addCompetitiveVehicle" class="w-100" @clicked="competitiveVehicleSelected=true"></ymmtlookup>
                        </b-col>
                        <b-col class="text-right" align-self="end">
                          <b-button class="btn btn-success mb-2 mt-2 mr-2" @click="competitiveVehicleAdded()"
                                    v-b-tooltip.hover title="Add selected vehicle to competitive list">
                            <i class="fa fa-plus"></i>
                          </b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="m-0 p-2" v-else>
            <div class="col-lg-6 offset-lg-2" style="text-align: center; height: 100%; opacity: 0.7; filter: alpha(opacity=70);">
              
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">No Vehicle Sets</h4>
            <p>Before you can modify competitive mapping, you must create at least one vehicle set. </p>
            <hr>
            <p class="mb-0">Click Vehicle Sets on the left under mScope to go to the Vehicle Set creation page.</p>
          </div>
        </b-row>
      </b-card>
    </div>
    <b-modal id="modal-prevent-closing"
             ref="modal"
             title="Save Set As"
             @ok="handleOk">

      <form ref="form" class="validationForm" data-vv-scope="NewTitle" @submit.stop.prevent="handleSubmit">
        <label>Name</label><br />
        <b-form-input id="report-input"
                      v-model="new_name"
                      v-validate="{required: true}" :maxlength="250"
                      v-bind:class="{'is-invalid': validateErrors.has('NewTitle.Name') }" name="Name"
                      required></b-form-input>
        <em class="error invalid-feedback">{{ validateErrors.first('NewTitle.Name') }}</em>
      </form>
    </b-modal>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Router from '@/router'
  import axios from 'axios'
  import loading from 'vue-full-loading'
  import notify from 'devextreme/ui/notify'
  import ymmtlookup from '../components/YMMTLookup'
  import multiselect from '../components/MultiVehicleSelect'
  import { Validator } from 'vee-validate'
  import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
  import ArrayStore from 'devextreme/data/array_store'
  import {
    DxTextBox,
    DxSlider,
    DxNumberBox,
    DxLookup,
    DxSelectBox,
    DxSwitch,
    DxDropDownBox,
    DxDateBox,
    DxButton,
    DxList

  } from 'devextreme-vue'
  import DxPopup, { DxToolbarItem } from 'devextreme-vue/popup'
  import { confirm, alert } from 'devextreme/ui/dialog'
  import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxPager,
    DxPaging
  } from 'devextreme-vue/data-grid'

  export default {
    components: {
      loading,
      DxTextBox,
      DxSlider,
      DxNumberBox,
      DxLookup,
      DxSelectBox,
      DxSwitch,
      DxDropDownBox,
      DxPopup,
      DxToolbarItem,
      DxDateBox,
      DxButton,
      DxList,
      DxDataGrid,
      DxColumn,
      DxHeaderFilter,
      DxSearchPanel,
      DxFilterRow,
      DxPager,
      DxPaging,
      ymmtlookup,
      multiselect,
      DxToolbar,
      DxItem
    },
    props: ['vehicleSetId', 'filteredModels'],
    created() {
      this.loadMappingSets()
      this.loadVehicleSets()
      this.initLoad = true
    },
    data() {
      return {
        errMsg: '',
        initLoad: true,
        changesSaved: true,
        dismissibleType: 'danger',
        showDismissibleAlert: false,
        boolLoading: false,
        txtLoading: 'Loading...',
        activeVehicle: null,
        activeVehicleId: [],
        activeVehicleSetId: [],
        activeMappingSet: { },
        trackedVehicles: [],
        allTrackedVehicles:[],
        vehicleSets: [],
        mappingSets: [],
        competitiveVehicleSelected: false,
        trackedVehicleSelected: false,
        currentMappedVehicles: [],
        addingMappingSet: false,
        new_name: '',
        addButtonOptions: {
          icon: 'plus',
          onClick: () => {
            colAddCompetitiveVehicle.show()
          }
        },
      }
    },
    methods: {
      handleOk(bvModalEvt) {
        bvModalEvt.preventDefault()
        if (this.new_name.length > 0) {
          const found = this.mappingSets.some(element => element.Name.trim() === this.new_name.trim())
          if (found) {
            this.validateErrors.add({ 'field': 'Name', 'scope': 'NewTitle', 'msg': 'Name is not unique' })
            return
          }
          this.saveMappingSetAs(this.new_name)
        }
      },
      loadVehicleSets() {
        axios.get('/api/mscope/loadvehiclesets')
          .then(response => {
            this.boolLoading = false
            this.vehicleSets = response.data
          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      },
      loadMappingSets() {
        //get mapping sets call
        var self = this
        axios.get('/api/mscope/getcompetitivemappingsets')
          .then(response => {
            if (response.data) {
              self.mappingSets = response.data
            }
            self.activeVehicle = null
          }).catch(error => {
            if (error.response.status === 403) { self.$router.push('/login') }
            self.errMsg = 'There was an error getting mapping sets : ' + error
            self.showDismissibleAlert = true
          })
      },  
      createMappingSet() {
        if (this.mappingSets.some(x => x.SetId == -1)) {
          alert("You must save your current untitled set before creating a new one.")
          return
        }
        var newSet = {}
        newSet.SetId = -1
        newSet.Name = '<Untitled>'
        this.mappingSets.push(newSet)
        this.changeActiveSet(newSet)
        this.changesSaved = false

      },
      saveMappingSetAs(name) {
        var self = this
        var obj = {
          SetId: -1,
          Name: name,
          CopyId: self.activeMappingSet.SetId,
          TrackedVehicles: self.allTrackedVehicles.filter(tv => tv.Changed == true)
        }
        axios.post('/api/mscope/savecompetitivemappingset', obj)
          .then(response => {
            if (response.data) {
              setTimeout(() => {
                self.loadMappingSets()
              }, 200)
              self.addingMappingSet = false
              setTimeout(() => {
                self.changesSaved = true
                console.log(response.data)
                notify('Competitive Mapping Set has been saved', 'success', 3500)                
                self.completeChange(response.data)
              }, 200)
              this.$nextTick(() => {
                this.$refs.modal.hide()
              })
            }
          }).catch(error => {
            if (error.response.status === 403) { self.$router.push('/login') }
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
          })
      },
      saveMappingSet() {
        var self = this

        if (self.activeMappingSet.Name == '<Untitled>') {
          var name = prompt('Please name the competitive mapping set', '<Untitled>')
          if (name != null)
            self.activeMappingSet.Name = name
          else {
            notify('Competitive Mapping Set save cancelled', 'warning', 3500)
            return
          }
        }
        var obj = {
          SetId: self.activeMappingSet.SetId,
          Name: self.activeMappingSet.Name,
          TrackedVehicles: self.allTrackedVehicles.filter(tv => tv.Changed == true)
        }
        axios.post('/api/mscope/savecompetitivemappingset', obj)
          .then(response => {
            if (response.data) {
              setTimeout(() => {
                self.loadMappingSets()
              }, 200)
              self.addingMappingSet = false
              setTimeout(() => {
                self.changesSaved = true
                notify('Competitive Mapping Set has been saved', 'success', 3500)
                self.loadMappingSet(response.data)
              }, 200)

            }
          }).catch(error => {
            if (error.response.status === 403) { self.$router.push('/login') }
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
          })
      },
      deleteMappingSet() {
        var self = this
        if (self.activeMappingSet.SetId < 0) {
          alert('You cannot delete this set because it has not been saved yet.')
          return
        }
        let result = confirm('Are you sure you want to delete the mapping set?', 'Warning')
        result.then((dialogResult) => {
          if (!dialogResult) {
            return
          } else {
            var obj = {
              SetId: self.activeMappingSet.SetId,
              Name: self.activeMappingSet.Name
            }
            axios.post('/api/mscope/deletecompetitivemappingsets', obj)
              .then(response => {
                //Router.push('/mScope/CompetitiveVehicleMapping')
                setTimeout(() => {
                  self.loadMappingSets(obj)
                  self.changeActiveSet({SetId:-1, Name:''})
                }, 200
              )
                
              }).catch(error => {
                if (error.response.status === 403) { self.$router.push('/login') }
                self.errMsg = 'There was an error getting data : ' + error
                self.showDismissibleAlert = true
              })
          }
        })

      },
      changeActiveSet(set) {
        var self = this
        if (self.changesSaved == false) {
          var result = confirm('You have unsaved changes to this set, are you sure you want to proceed?')
          result.then((dialogResult) => {
            if (!dialogResult) {
              return
            } else {
              this.mappingSets = this.mappingSets.filter(x => x.SetId > 0)
              self.completeChange(set)
            }
          })
        }
        else {
          self.completeChange(set)
        }
      },
      completeChange(set) {
        this.activeVehicle = null
        this.currentMappedVehicles = null
        this.activeMappingSet = set
        this.loadMappingSet(set)
        this.changesSaved = true
      },
      changeActiveTrackedVehicle(vehId) {
        var self = this

        self.activeVehicle = self.allTrackedVehicles.find(x => x.VehicleID == vehId)
        self.loadCompetitiveVehiclesDetails(self.activeVehicle)
        self.competitiveVehicleSelected = false


      },
      selectTrackedVehicle() {
        var vehId = this.$refs.lookupVehicle.selectedVehicleID
        if (vehId) {
          this.changeActiveTrackedVehicle(vehId)
        }
        else {
          self.errMsg = 'There was an error selecting target vehicle : ' + error
          self.showDismissibleAlert = true
        }
      },
      competitiveVehicleAdded() {
        var self = this
        if (!self.activeVehicle) {
          alert("Please select a vehicle from a vehicle set first.")
          return
        }
        var vehid = self.$refs.addCompetitiveVehicle.selectedVehicleID
        if (vehid <1) {
          alert("Please select a vehicle to add first.")
          return
        }
        var obj = { isNew: 1, vehicleId: vehid }

        axios.post('/api/mscope/findCompetitiveVehicle', obj)
          .then(response => {
            if (response.data) {
              response.data.forEach(function (cv) {
                if (!self.currentMappedVehicles.some(e => e.VehicleID === cv.VehicleID)) {
                  cv.LongDescription = self.getVehicleName(cv)
                  self.currentMappedVehicles.unshift(cv)
                  var vehicle = self.allTrackedVehicles.find(tv => tv.VehicleID == self.activeVehicle.VehicleID)
                  vehicle.MappedIds.push(cv.VehicleID)
                  vehicle.Changed = true
                  self.changesSaved = false
                }
              })
            }
            self.competitiveVehicleSelected = false
          }).catch(error => {
            if (error.response.status === 403) { self.$router.push('/login') }
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
          })
      },
      loadMappingSet(set) {
        //load dealerships customized vehicle mapping set
        var self = this
        self.boolLoading = true
        var obj = { setId: set.SetId, setName: set.Name }
        axios.post('/api/mscope/gettrackedvehiclesforset', obj)
          .then(response => {
            if (response.data) {
              self.vehicleSets = response.data.VehicleSets
              self.allTrackedVehicles = response.data.TrackedVehicles
              self.activeVehicleSetId = parseInt(self.vehicleSets[0].VehicleSetId)
              self.trackedVehicles = self.allTrackedVehicles.filter(v => v.VehicleSets.includes(self.activeVehicleSetId))
              self.allTrackedVehicles.forEach(function (tv) {
                tv.LongDescription = self.getVehicleName(tv)
                tv.id = tv.VehicleID
              })
            }
            else {
              self.trackedVehicles = []
            }
            self.boolLoading = false
          })
          .catch(error => {
            if (error.response.status === 403) { self.$router.push('/login') }
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
            self.boolLoading = false
          })

      },
      //loadCompetitiveVehicles(vehid) {
      //  //use the selected vehicle ID to obtain the competitive vehicle set
      //  var self = this
      //  var obj = { isnew: 1, vehicleId: vehid, setId: self.activeMappingSet.SetId }
      //  self.boolLoading = true
      //  axios.post('/api/mscope/getcompetitivevehicles', obj)
      //    .then(response => {
      //      self.changesSaved = false
      //      self.currentMappedVehicles = response.data
      //      self.currentMappedVehicles.forEach(function (tv) {
      //        tv.LongDescription = self.getVehicleName(tv)
      //      })
      //      self.boolLoading = false
      //      self.trackedVehicleSelected = true
      //    })
      //    .catch(error => {
      //      if (error.response.status === 403) { this.$router.push('/login') }
      //      console.log(error)
      //      self.errMsg = 'There was an error getting competitive vehicles : none found '
      //      self.showDismissibleAlert = true
      //      self.boolLoading = false
      //    })
      //
      //},
      loadCompetitiveVehiclesDetails(veh) {
        //use the selected vehicle ID to obtain the competitive vehicle set
        var self = this
        var obj = { isnew: 1, vehicleId: veh.VehicleID, mappedIds: veh.MappedIds }
        self.boolLoading = true
        axios.post('/api/mscope/getcompetitivevehicledetails', obj)
          .then(response => {
            self.currentMappedVehicles = response.data
            self.currentMappedVehicles.forEach(function (tv) {
              tv.LongDescription = self.getVehicleName(tv)
            })

            self.trackedVehicleSelected = true
            self.boolLoading = false
          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }
            console.log(error)
            self.errMsg = 'There was an error getting competitive vehicles : none found '
            self.currentMappedVehicles = []
            self.showDismissibleAlert = true
            self.boolLoading = false
          })

      },
      addMSISCompetitiveVehicles() {
        //use the selected vehicle ID and msis setID to obtain the competitive vehile set and add it
        var self = this
        if (!self.activeVehicle) {
          alert("Please select a vehicle from a vehicle set first.")
          return
        }
        let result = confirm('Are you sure you want to restore MSIS mappings to your mapping set?', 'Warning')
        result.then((dialogResult) => {
          if (!dialogResult) {
            return
          } else {
            var obj = { isnew: 1, vehicleId: self.activeVehicle.VehicleID, setId: -1 }
            self.boolLoading = true
            axios.post('/api/mscope/getcompetitivevehicles', obj)
              .then(response => {
                self.changesSaved = false
                self.currentMappedVehicles.append = response.data
                var vehicle = self.allTrackedVehicles.find(tv => tv.VehicleID == self.activeVehicle.VehicleID)
                response.data.forEach(function (cv) {
                  console.log(vehicle)
                  if (!vehicle.MappedIds.includes(cv.VehicleID)) {
                    cv.LongDescription = self.getVehicleName(cv)
                    self.currentMappedVehicles.unshift(cv)
                    vehicle.MappedIds.push(cv.VehicleID)
                    vehicle.Changed = true
                    self.changesSaved = false
                  }
                })
                self.boolLoading = false
              })
              .catch(error => {
                if (error.response.status === 403) { this.$router.push('/login') }
                console.log(error)
                self.errMsg = 'There was an error getting competitive vehicles : none found '
                self.showDismissibleAlert = true
                self.boolLoading = false
              })
          }
        })

      },
      getVehicleName(vehicle) {
        if (vehicle)
          return `${vehicle.Year} ${vehicle.Make} ${vehicle.Model} ${vehicle.ShortDescription} (${vehicle.MsCode})`
      },
      //saveCompetitiveSet() {
      //  var self = this
      //  if (!self.activeVehicle) {
      //    alert("Please select a tracked vehicle first.")
      //    return
      //  }
      //  self.boolLoading = true

      //  var obj = {
      //    vehicleId: self.activeVehicle.VehicleID,
      //    setId: self.activeMappingSet.SetId,
      //    data: self.currentMappedVehicles.map(a => a.VehicleID)
      //  }
      //  self.$validator.validateAll().then((result) => {
      //    if (result) {
      //      axios.post('/api/mscope/savecompetitiveset', obj)
      //        .then(response => {
      //          setTimeout(function () {
      //            self.changesSaved = true
      //            notify('Competitive Set has been saved', 'success', 3500)
      //            self.trackedVehicleSelected = false
      //            self.activeVehicle = undefined
      //            self.currentMappedVehicles = []
      //            self.loadMappingSet(self.activeMappingSet)
      //          }, 500)

      //        })
      //        .catch(error => {
      //          if (error.response.status === 403) { this.$router.push('/login') }
      //          console.log(error.response)
      //          this.errMsg = 'There was an error saving: ' + error.response.statusText
      //          this.showDismissibleAlert = true
      //          notify('Error saving vehicle set', 'error', 3500)
      //        })
      //    }
      //  })
      //  self.boolLoading = false

      //},
      isDefaultSelected() {
        return (this.activeMappingSet === undefined || this.activeMappingSet.SetId < 0)
      },
      selectionChanged(e) {
        alert(e)
      },
      competitiveVehicleDeleted(e) {
        var self = this
        var vehicle = self.allTrackedVehicles.find(tv => tv.VehicleID == self.activeVehicle.VehicleID)
        var delIndex = vehicle.MappedIds.indexOf(e.itemData.VehicleID)
        if (delIndex > -1)
          vehicle.MappedIds.splice(delIndex, 1)
        vehicle.Changed = true
        self.changesSaved = false
      },
      getImgUrl(makeid) {
        var images = require.context('@/assets/makes/', false, /\.jpg$/)
        let makeImage = ''
        try {
          makeImage = images(`./${makeid}.jpg`)
        } catch (error) {
          //makeImage = images(`./no_image.jpg`)
        }
        return makeImage

      }

    },
    beforeRouteLeave(to, from, next) {
      if (!this.changesSaved) {
        let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
        result.then((dialogResult) => {
          if (!dialogResult) {
            return next(false)
          } else {
            return next()
          }
        })
      } else {
        return next()
      }
    },
    computed: {

    },
    mounted() {
      // boolLoading must be set to false on data() binding so that mount hooks the change
      this.boolLoading = false
    },
    watch: {
      activeVehicleSetId: function (val, oldval) {
        if (oldval != val)
          this.trackedVehicles = this.allTrackedVehicles.filter(v => v.VehicleSets.includes(val))
      },
      //activeVehicleId: {
      //  handler: function (val, oldVal) {
      //    console.log(val)
      //    this.changeActiveTrackedVehicle(val[0])
      //  },
      //  deep: true
      //}
    }
  }
</script>

<style scoped>
  .h4 {
    margin-bottom: -5.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/mScopeCompetitiveVehicleMapping.vue